import React from "react";
import "./Maintenance.css";

const Maintenance: React.FC = () => {
    return (
        <div className="maintenance-container">
            <div className="maintenance-card">
                {/* Maintenance Icon - Gear with wrench */}
                <div className="maintenance-icon">
                    <svg
                        width="96"
                        height="96"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        {/* Gear */}
                        <path
                            d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                            stroke="#4f5dca"
                            strokeWidth="1.5"
                        />
                        <path
                            d="M13.7 2.5h-3.4l-.5 2.1a7 7 0 0 0-2 1.2L5.8 5l-1.7 3 1.5 1.6a7 7 0 0 0 0 2.3L4 13.5l1.7 3 2.1-.8a7 7 0 0 0 2 1.2l.5 2.1h3.4l.5-2.1a7 7 0 0 0 2-1.2l2.1.8 1.7-3-1.5-1.6a7 7 0 0 0 0-2.3L20 8l-1.7-3-2.1.8a7 7 0 0 0-2-1.2l-.5-2.1Z"
                            stroke="#4f5dca"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <h1 className="maintenance-title">Under Maintenance</h1>

                <p className="maintenance-text">
                    We're currently performing scheduled maintenance.
                    <br />
                    Please check back shortly.
                </p>

                <p className="maintenance-contact">
                    For queries: admissions2026@iiitb.ac.in | +91 80 4140 7777
                </p>
            </div>
        </div>
    );
};

export default Maintenance;
